import i18n from "@/i18n";

export function translateMessage(key: string, params?: any): string {
  return i18n.global.t(key, params);
}

const NON_SEAM_LENGTH_STITCHES: ReadonlySet<string> = new Set([
  "1012",
  "1013",
  "1015",
  "1016",
  "3012",
  "3013",
  "3015",
  "3042",
  "3043",
  "3045",
  "4012",
  "4013",
  "4012G",
  "4013G",
  "4042",
  "4043",
  "4045"
]);

// these stitch types are counted per piece, not per length of seam
export function isNonSeamLengthStitch(stitchCode?: string): boolean {
  return !!stitchCode && NON_SEAM_LENGTH_STITCHES.has(stitchCode);
}

export function getConsumptionHeader(seamLengthUnit: number, stitchCode?: string): string {
  const baseText = translateMessage ? translateMessage("operationCreateComp.consumption") : "Consumption";

  return withSeamLengthSuffix(baseText, seamLengthUnit, stitchCode);
}

// appends "10 cm" / "3.94 inch" unless the stitch type is counted per piece
export function withSeamLengthSuffix(label: string, seamLengthUnit: number, stitchCode?: string): string {
  if (isNonSeamLengthStitch(stitchCode)) {
    return label;
  }

  return seamLengthUnit === 0 ? label + " 10 cm" : label + " 3.94 inch";
}
